import redirectPermanently from '@/components/Redirect/redirectPermanently';

const Events = () => redirectPermanently('/eventos');

export default Events;
